<template>
  <div id="app" style="display:none;">
      <app-Header></app-Header>
            <transition name="fade" mode="out-in" appear>              
                <router-view :key="$route.fullPath"></router-view>
            </transition>
        <app-Footer></app-Footer>
            <back-to-top bottom="50px" right="50px">
            <button type="button" class="btn btn-info btn-to-top" style="background-color: #052962"><i class="fa fa-chevron-up"></i></button>
            </back-to-top>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
    name: 'app',
        components: {
        appHeader: Header,
        appFooter: Footer
    }
}
</script>

<style>
    @import '/src/assets/vendor/owl.carousel2/owl.carousel.min.css';
    @import '/src/assets/vendor/custom-icon/style.css';
    @import '/src/assets/vendor/font-awesome/css/font-awesome.min.css';
    @import '/src/assets/css/newstoday.min.css';

    .fade-enter-active, .fade-leave-active {
        transition-duration: 0.6s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }

    .vueperslides__bullet .default {
        color: white;
    }

    .btn-info {
        color: #fff;
        background-color: #052962;
        border-color: #052962;
    }

    .btn-info:hover {
        background-color: #093f96;
    }
</style>





// WEBPACK FOOTER //
// src/App.vue